export default __webpack_public_path__ + "static/SSSpyView_screenshot-1@2x-b2dcae4806adaf1f956e8e8f51f9a9ca.webp";